module.exports = __webpack_public_path__ + "img/vps_icon.3a7f97e.png";